import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreferenceService } from '../../services/preference.service';
import { UserNotificationPreference, NotificationPreference } from '../models/preference.model';
import { MatSelectChange } from '@angular/material/select';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { finalize } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-email-preferences',
  templateUrl: './email-preferences-v2.component.html',
  styleUrls: ['./email-preferences-v2.component.scss'],
})
export class EmailPreferencesV2Component implements OnInit {
  preferenceData: UserNotificationPreference | null = null;
  token: string | null = null;
  paramAvailability = true;
  loadError = false;
  private dirtyPreferences: NotificationPreference[] = [];

  constructor(
    private preferenceService: PreferenceService,
    private router: Router,
    private fuseSplashScreenService: FuseSplashScreenService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('code');

    if (!this.token) {
      this.paramAvailability = false;
      this.loadError = true;
      return;
    }

    this.preferenceService.getPreferenceV2(this.token)
      .pipe(finalize(() => this.fuseSplashScreenService.hide()))
      .subscribe({
        next: (data: UserNotificationPreference) => {
          this.preferenceData = data;
        },
        error: (err) => {
          console.error('getPreferenceV2 failed', err);
          this.loadError = true;
        }
      });
  }

  updatePreference(): void {
    if (!this.token) return;

    this.preferenceService
      .setPreferenceV2({
        id: this.token,
        notificationPreferences: this.dirtyPreferences,
        waitForResponse: true,
      })
      .subscribe({
        next: (data: UserNotificationPreference) => {
          this.preferenceData = data;
          this.dirtyPreferences = [];
          this.router.navigate(['/user-consent/UpdatePreference/update-successful']);
        },
        error: (err) => {
          console.error('setPreferenceV2 failed', err);
        }
      });
  }

  onSelectionChange($event: MatSelectChange, index: number): void {
    if (!this.preferenceData) return;

    const pref = this.preferenceData.notificationPreferences[index];
    const selected = pref.preferenceOptions.find(o => o.id === $event.value);
    if (selected) {
      pref.selectedPreference = selected;
      this.updateDirtyPreference(pref);
    }
  }

  private updateDirtyPreference(preference: NotificationPreference): void {
    const idx = this.dirtyPreferences.findIndex(p => p.id === preference.id);
    if (idx < 0) this.dirtyPreferences.push({ ...preference });
    else this.dirtyPreferences[idx] = { ...preference };
  }
}
